var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinAngle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pin-angle",
    transform: "translate(-3.928 -2.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13026",
    "data-name": "Group 13026",
    transform: "translate(3.928 2.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12972",
    "data-name": "Path 12972",
    d: "M14.3,2.166a.609.609,0,0,1,.431.178L20.75,8.368a.609.609,0,0,1,0,.86,2.536,2.536,0,0,1-1.829.716,3.4,3.4,0,0,1-.56-.047l-3.814,3.814a7.213,7.213,0,0,1,.195,1.233,3.686,3.686,0,0,1-.876,2.89.609.609,0,0,1-.86,0L9.562,14.392,5.69,18.265c-.237.237-1.484,1.1-1.721.86s.623-1.485.86-1.721L8.7,13.532,5.26,10.089a.609.609,0,0,1,0-.86,3.681,3.681,0,0,1,2.89-.876,7.207,7.207,0,0,1,1.233.195L13.2,4.734a3.374,3.374,0,0,1-.049-.561,2.536,2.536,0,0,1,.717-1.829.609.609,0,0,1,.43-.178Zm.148,2.57v0Zm0,0v0a.609.609,0,0,1-.148.621l-4.3,4.3a.609.609,0,0,1-.622.146h0l-.017,0Q9.178,9.747,9,9.707a5.99,5.99,0,0,0-.931-.141,3.214,3.214,0,0,0-1.43.183l6.706,6.7a3.234,3.234,0,0,0,.181-1.43,5.993,5.993,0,0,0-.234-1.283l0-.016h0a.609.609,0,0,1,.146-.623l4.3-4.3a.609.609,0,0,1,.647-.14l.117.027a2.212,2.212,0,0,0,.419.041,1.679,1.679,0,0,0,.417-.049L14.416,3.755a1.686,1.686,0,0,0-.049.417,2.165,2.165,0,0,0,.075.56Z",
    transform: "translate(-3.928 -2.166)",
    fill: "#600097"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinAngle);
export default __webpack_public_path__ + "static/media/pin-angle.9e02a1984abd25634f759c40c35c1cff.svg";
export { ForwardRef as ReactComponent };